import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { AuthService } from './auth.service';
import {GlobalVariable} from './../global';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private baseUrl: string = GlobalVariable.BASE_URL;
  private lang: string = localStorage.getItem('site_lang') ?? 'en';

  private userProfileCache$: Observable<any> | null = null;
  private userProfileCacheToken: string | null = null;

  constructor(private http: HttpClient, private auth:AuthService) { }

  restPasswordRequest(Obj:any, lang: any){
    const apiKey = this.auth.getToken();
    let targetUrl = this.baseUrl + "/user/password-reset-request";
    const headers = {
      'Accept-Language': lang === 'en' ? 'en-US' : 'ja-JP'
    };

    return this.http.post<any>(targetUrl, Obj,{ headers });
  }
  
  restPassword(Obj: any, lang: any) {
    const apiKey = this.auth.getToken();
    let targetUrl = this.baseUrl + "/user/password-reset-by-token";
    const headers = {
      'Accept-Language': lang === 'en' ? 'en-US' : 'ja-JP'
    };

    return this.http.post<any>(targetUrl, Obj,{ headers });
  }
  
  restInitPassword(Obj: any) {
    const apiKey = this.auth.getToken();
    let targetUrl = this.baseUrl + "/user/change-password-resetbyadmin";
    const headers = {
      'Accept-Language': this.lang === 'en' ? 'en-US' : 'ja-JP'
    };

    return this.http.post<any>(targetUrl, Obj,{ headers });
  }

  changePasswordExpired(Obj: any) {
    let targetUrl = this.baseUrl + "/user/change-password-expired";
    const headers = {
      'Accept-Language': this.lang === 'en' ? 'en-US' : 'ja-JP'
    };

    return this.http.post<any>(targetUrl, Obj, { headers });
  }

  getUserProfile(): Observable<any> {
    const currentToken = this.auth.getToken();
    const isCacheValid = this.userProfileCache$ !== null
      && this.userProfileCacheToken === currentToken;
    if (!isCacheValid) {
      this.userProfileCacheToken = currentToken;
      const apiUrl = this.baseUrl + '/user/details';
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${currentToken}`
      };
      this.userProfileCache$ = this.http.get<any>(apiUrl, { headers }).pipe(shareReplay(1));
    }
    return this.userProfileCache$!;
  }

  clearUserProfileCache(): void {
    this.userProfileCache$ = null;
    this.userProfileCacheToken = null;
  }

 changePassword(Obj:any){
  const apiKey = this.auth.getToken();
    let targetUrl = this.baseUrl + "/user/change-password";
   const headers = {
      lang: this.lang,
      Authorization: `Bearer ${apiKey}`
    };

    return this.http.put<any>(targetUrl, Obj,{ headers });
  }

  changeEmail(Obj:any){
    const apiKey = this.auth.getToken();
    let targetUrl = this.baseUrl + "/user/register-notification-email";
    const headers = {
      lang: this.lang,
      Authorization: `Bearer ${apiKey}`
    };

    return this.http.post<any>(targetUrl, Obj,{ headers });
  }
  
  giveConsent(Obj: any) {
    const apiKey = this.auth.getToken();
    let targetUrl = this.baseUrl + "/logagreement/insert";
    const headers = {
      lang: this.lang,
      Authorization: `Bearer ${apiKey}`
    };

    return this.http.post<any>(targetUrl, Obj,{ headers });
  }

  acceptChangeEmail(Obj:any){
  const apiKey = this.auth.getToken();
    let targetUrl = this.baseUrl + "/user/emailconfirmed";
    const headers = {
      lang: this.lang,
      Authorization: `Bearer ${apiKey}`
    };

    return this.http.put<any>(targetUrl, Obj,{ headers });
  }
}
